<div class="custom-menu">
  <div *ngFor="let section of items" class="menu-section">
    <div class="section-header" [class.expanded]="section.expanded" [class.favorites]="isFavoriteSection(section.id || '')" (click)="toggleSection(section.id || '')">{{section.label}}</div>
    <div *ngIf="section.expanded" class="section-items">
      <div *ngFor="let item of section.items" class="menu-item" [class.active-report]="item.styleClass === 'active-report'">
        <span class="report-text" (click)="navigateToReport(item.id || '')">{{getItemLabel(item)}}</span>
        <span *ngIf="isFavoriteSection(section.id || '')" class="star-wrapper" (click)="toggleFavorite(item.id || '', getItemLabel(item))" [title]="'Unfavourite this report'">
          <i class="pi" [class]="getStarClass(item.id || '')"></i>
        </span>
      </div>
    </div>
  </div>
</div>
